<div class="error-container alert-danger">
    <i aria-hiddes="true" class="fas fa-exclamation-circle"></i>
    <span>{{message}}</span>
</div>